<div>
  <div class="mb-3">
    <label for="deviceid" class="form-label">Device ID</label>
    <input [(ngModel)]="deviceid" type="text" class="form-control" name="deviceid" disabled>
  </div>
  <div class="mb-3">
    <label for="description" class="form-label">Description</label>
    <input [(ngModel)]="description" type="text" class="form-control" name="description">
  </div>
  <div class="mb-3">
    <label for="department" class="form-label">Department</label>
    <select class="form-control" aria-label="Select a department" name="department" [(ngModel)]="department_id">
      <option *ngFor="let item of departments[0]" value="{{item.id}}">{{item.name}}</option>
    </select>
  </div>
  <button (click)="save()" class="btn btn-primary">Save</button>
  <button class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#removeModal">Remove</button>
  <button (click)="cancel()" class="btn btn-primary">Cancel</button>
</div>

<!-- Modal -->
<div class="modal fade" id="removeModal" tabindex="-1" aria-labelledby="removeModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="removeModalLabel">Delete device '{{deviceid}}'</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Do you really want to remove the device '<span style="font-weight: bold;">{{deviceid}}</span>' ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="delete()" data-bs-dismiss="modal">Remove</button>
      </div>
    </div>
  </div>
</div>